/* eslint-disable import/order */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { FC, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '~/components';
import FormDrawer from '~/components/FormDrawer';
import { PersonAddIcon } from '~/img';

import buildNamePath from '~/utils/buildNamePath';
import { ApplicationPayload } from '~/types/ApplicationPayload';
import styled from 'styled-components';
import _, { isEmpty, set } from 'lodash';
import AdministratorAddForm, { formName } from './AdministratorAddForm';
import { formatMobileNumber } from '~/utils/formatUtilis';
import { setAddingExistingUserValues, setIsCopyingBtnPressed } from '~/slices/state';
import Form from '~/components/WizardForm';
import { List, Modal, Space, Button as AntdButton } from 'antd';
import { useCheckMatchingContact } from '~/controllers/contacts';
import { Contacts } from '~/types/Contacts';
import { Person } from '~/types/Person';

const AdministratorAdd: FC = (props) => {
  const {
    isSpinning,
    setIsSpinning,
    value,
    onSave,
    selectedValue,
    setSelectedValue,
    adminType,
    isDisabled = false,
    applicationData,
    servicesDetailsData,
    index,
  } = props as any;
  const administratorsFormState = value as any[];
  const [listOfEmails, setListOfEmails] = useState<any[]>();
  const [listOfPhoneNumber, setListOfPhoneNumber] = useState<any[]>();
  const [sFMultiErr, setSFMultiErr] = useState<any>(false);
  const dispatch = useDispatch();

  const {
    payload: { users },
  } = applicationData;
  const [form] = Form.useForm();

  const salesForcepayload = useMemo(() => {
    const authorizedRepresentative = applicationData?.payload?.authorizedRepresentative;
    const individuals = applicationData?.payload?.shareholders?.individuals;
    const businesses = applicationData?.payload?.shareholders?.businesses;
    const beneficialOwners = applicationData?.payload?.shareholders?.beneficialOwners;
    const listOfpreMobileNumbers = [
      ...(Array.isArray(authorizedRepresentative) ? authorizedRepresentative : []),
      ...(Array.isArray(individuals) ? individuals : []),
      ...(Array.isArray(businesses) ? businesses : []),
      ...(Array.isArray(beneficialOwners) ? beneficialOwners : []),
    ];

    return listOfpreMobileNumbers?.map((item) => {
      return item?.data || item;
    });
  }, []);

  const administrators = useMemo(() => {
    const sspUsers = users?.selfServiceUsers || [];
    const virtualCardDataExpenseManagementUsers = users?.dataExpenseManagementAndVirtualCardUsers || [];
    return [...(adminType === 'selfServiceUsers' ? sspUsers : virtualCardDataExpenseManagementUsers)];
  }, [adminType, users?.dataExpenseManagementAndVirtualCardUsers, users?.selfServiceUsers]);

  // some of the users might be in draft data
  const administratorsDraftData = useMemo(() => {
    const sspUsers = servicesDetailsData?.data?.users?.selfServiceUsers || [];
    const virtualCardDataExpenseManagementUsers =
      servicesDetailsData?.data?.users?.dataExpenseManagementAndVirtualCardUsers || [];
    return [...(adminType === 'selfServiceUsers' ? sspUsers : virtualCardDataExpenseManagementUsers)];
  }, [
    adminType,
    servicesDetailsData?.data?.users?.dataExpenseManagementAndVirtualCardUsers,
    servicesDetailsData?.data?.users?.selfServiceUsers,
  ]);

  // TODO: we should remove this
  // Store all the email address and phone number of all the administrators to check duplicates before adding a new admin
  useEffect(() => {
    const emailList = [...administrators.map((a: any) => a.email), ...administratorsDraftData.map((a: any) => a.email)];
    setListOfEmails(emailList);
    const phoneList = [
      ...administrators.map((a: any) => a.mobileNo),
      ...administrators.map((a: any) => a.phoneNo),
      ...administratorsDraftData.map((a: any) => a.mobileNo),
      ...administratorsDraftData.map((a: any) => a.phoneNo),
    ].filter((p) => p);
    setListOfPhoneNumber(phoneList);
  }, [administrators, administratorsDraftData, applicationData]);
  // //////////////////////////////////////////////////////////////////
  const { t } = useTranslation('administrator');
  const [open, setOpen] = useState(selectedValue && !_.isEmpty(selectedValue));
  const handleOpenForm = () => {
    setSelectedValue({});
    setOpen(true);
  };
  const handleClose = () => {
    setSelectedValue({});
    setOpen(false);
    setSFMultiErr(false);
  };

  useEffect(() => {
    if (selectedValue && !_.isEmpty(selectedValue)) {
      setOpen(true);
    }
  }, [selectedValue]);

  const newShareholderIndex = administratorsFormState?.length ?? 0;

  const checkMatchingContact = useCheckMatchingContact();
  const [matchingContactList, setMatchingContactList] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedContact, setSelectedContact] = useState<Person>();
  const [resolveMatchingPromise, setResolveMatchingPromise] = useState<
    ((value: { choice: 'new' | 'select'; selectedContact?: Person }) => void) | null
  >(null);

  const handleMatchingModalAsync = async () => {
    return new Promise<{ choice: 'new' | 'select'; selectedContact?: Person }>((resolve) => {
      setResolveMatchingPromise(() => resolve);
    });
  };

  const handleCreateNewContact = () => {
    if (resolveMatchingPromise) {
      resolveMatchingPromise({ choice: 'new' });
      setResolveMatchingPromise(null);
    }
    setModalOpen(false);
    setMatchingContactList([]);
  };

  const handleSelectContact = () => {
    if (resolveMatchingPromise && selectedContact) {
      resolveMatchingPromise({ choice: 'select', selectedContact });
      setResolveMatchingPromise(null);
    }
    setModalOpen(false);
    setMatchingContactList([]);
  };

  const state = useSelector((state: any) => state?.state);
  const { isCopyingBtnPressed } = state;

  const onFinish = async (newValues: ApplicationPayload) => {
    setIsSpinning(true);
    const recordData = newValues?.users[0]?.data;
    let proceedWithSave = true;
    if (!isCopyingBtnPressed && isEmpty(selectedValue)) {
      const matchingContactList = await checkMatchingContact.mutateAsync(recordData);
      const matchType = matchingContactList[0]?.matchType;
      const contactIdList = matchingContactList.map((contact: Contacts['contacts']) => contact.contactId);

      switch (matchType) {
        case 'FULL_MATCH':
          set(recordData, 'contactId', contactIdList[0]);
          set(recordData, 'matchContactId', contactIdList[0]);
          break;
        case 'PARTIAL_MATCH': {
          setMatchingContactList(matchingContactList);
          setSelectedContact(undefined);
          setModalOpen(true);
          const result = await handleMatchingModalAsync();
          if (result.choice === 'select' && result.selectedContact) {
            set(recordData, 'contactId', result.selectedContact.contactId);
            set(recordData, 'matchContactId', result.selectedContact.contactId);
          }
          break;
        }
        default:
      }
    }

    let err = false;
    salesForcepayload?.forEach((item) => {
      if (
        (formatMobileNumber(item?.phoneNumber) === formatMobileNumber(recordData?.phoneNo) ||
          formatMobileNumber(item?.phoneNumber) === formatMobileNumber(recordData?.mobileNo)) &&
        !err
      ) {
        if (item?.email && !err) {
          if (item?.email !== recordData?.email && !err) {
            err = true;
          }
        }
        if ((item?.firstName !== recordData?.firstName || item?.lastName !== recordData?.lastName) && !err) {
          err = true;
        }
      }
    });

    if (err) {
      setSFMultiErr(err);
      proceedWithSave = false;
    }

    if (proceedWithSave) {
      onSave(newValues?.users[0]);
      handleClose();
    }
    ///
    dispatch(setAddingExistingUserValues({} as any));
    dispatch(setIsCopyingBtnPressed(false as any));
  };

  const titleMap: any = {
    selfServiceUsers: t('administrator.modal.addNewSSPUser'),
    dataExpenseManagementAndVirtualCardUsers: t('administrator.modal.addNewDataExpenseManagementAndVirtualCardUsers'),
  };

  const title =
    adminType && adminType in titleMap ? titleMap[adminType] : t('administrator.modal.addNewAdmin').toUpperCase();

  return (
    <Container>
      <Space className="btns-space" direction="vertical" size={25}>
        <Button
          adaptive
          onClick={handleOpenForm}
          id="addNewAdminUser"
          extraLarge
          type="default"
          icon={<PersonAddIcon />}
          disabled={isDisabled}
        >
          {title}
        </Button>
        <Button
          adaptive
          onClick={(value: any) => {
            const isPresssed: any = !!value;
            handleOpenForm();
            dispatch(setIsCopyingBtnPressed(isPresssed));
          }}
          id="addNewAdminUser"
          extraLarge
          type="default"
          icon={<PersonAddIcon />}
          disabled={isDisabled}
        >
          Copy profile from existing contacts
        </Button>
      </Space>
      <FormDrawer
        id="adminAddDrawer"
        visible={open}
        onClose={handleClose}
        title={selectedValue && !_.isEmpty(selectedValue) ? t('administrator.modal.editAdmin') : title}
        formName={formName}
        sFMultiErr={sFMultiErr}
      >
        <Modal
          open={modalOpen}
          title="This contact matches existing contacts. If you wish to update any of the contacts below, please select the contact you want to update, or create a new contact"
          onCancel={() => {
            setModalOpen(false);
            setMatchingContactList([]);
            setIsSpinning(false);
            setResolveMatchingPromise(null);
            setSelectedContact(undefined);
          }}
          footer={[
            <AntdButton key="newContact" onClick={handleCreateNewContact}>
              {t('Create New Contact')}
            </AntdButton>,
            <AntdButton key="select" type="primary" disabled={!selectedContact} onClick={handleSelectContact}>
              {t('Select')}
            </AntdButton>,
          ]}
        >
          <List
            dataSource={matchingContactList}
            renderItem={(item: Person) => (
              <List.Item
                onClick={() => setSelectedContact(item)}
                style={{
                  cursor: 'pointer',
                  backgroundColor: selectedContact?.contactId === item.contactId ? '#e6f7ff' : 'transparent',
                  padding: '8px',
                  borderRadius: '4px',
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word',
                }}
              >
                {`Name: ${item.firstName} ${item.lastName}`}
                <br />
                {`Roles: ${item.userRoles?.join(' - ')}`}
              </List.Item>
            )}
          />
        </Modal>
        <AdministratorAddForm
          isSpinning={isSpinning}
          applicationData={applicationData}
          index={index}
          onFinish={onFinish}
          initialValues={value}
          selectedValue={selectedValue}
          adminType={adminType}
          listOfEmails={listOfEmails}
          listOfPhoneNumber={listOfPhoneNumber}
          n={buildNamePath(['users', newShareholderIndex])}
          {...props}
        />
      </FormDrawer>
    </Container>
  );
};

const Container = styled.div`
  .btns-space {
    width: 100%;
  }
  // #addNewAdminUser {
  //   position: absolute;
  //   width: 50%;
  //   bottom: 36px;
  // }
`;

export default AdministratorAdd;
